(() => {
  'use strict';
  if (window.__ossJerseyArtworkInstalled) return;
  window.__ossJerseyArtworkInstalled = true;

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const clean = (value) => String(value == null ? '' : value).trim();
  const parseJson = (node) => {
    if (!node) return {};
    try { return JSON.parse(node.textContent) || {}; } catch (_) { return {}; }
  };
  const absoluteUrl = (url) => {
    try { return new URL(url, window.location.href).href; } catch (_) { return clean(url); }
  };

  const artwork = parseJson(qs('[data-oss-artwork-config]'));
  const patchArtwork = Array.isArray(artwork.patches) ? artwork.patches : [];
  const FILE_BASE = '/cdn/shop/files/';

  const slugForName = (name) => {
    const value = clean(name).toLowerCase();
    if (value.includes('conference league')) return 'conference-league';
    if (value.includes('champions league')) return 'champions-league';
    if (value.includes('europa league')) return 'europa-league';
    if (value.includes('bundesliga')) return 'bundesliga';
    if (value.includes('laliga') || value.includes('la liga')) return 'laliga';
    if (value.includes('serie a')) return 'serie-a';
    if (value.includes('premier league')) return 'premier-league';
    if (value.includes('ligue 1')) return 'ligue-1';
    if (value.includes('primeira liga') || value.includes('liga portugal')) return 'primeira-liga';
    if (value.includes('mls')) return 'mls';
    if (value.includes('eredivisie')) return 'eredivisie';
    if (value.includes('süper lig') || value.includes('super lig')) return 'super-lig';
    return 'generic';
  };

  const autoLogoUrl = (slug) => slug === 'generic' ? '' : `${FILE_BASE}oss-patch-logo-${slug}.png`;
  const autoBackgroundUrls = (slug) => slug === 'generic' ? [] : [
    `${FILE_BASE}oss-patch-bg-${slug}.webp`,
    `${FILE_BASE}oss-patch-bg-${slug}.jpg`,
    `${FILE_BASE}oss-patch-bg-${slug}.png`
  ];

  const probeFirst = (urls, done) => {
    const candidates = urls.filter(Boolean);
    let index = 0;
    const next = () => {
      if (index >= candidates.length) {
        done('');
        return;
      }
      const url = candidates[index++];
      const probe = new Image();
      probe.decoding = 'async';
      probe.onload = () => {
        if (probe.naturalWidth && probe.naturalHeight) done(url);
        else next();
      };
      probe.onerror = next;
      probe.src = url;
    };
    next();
  };

  const applyTeamBanner = () => {
    const banner = qs('.oss-club-banner');
    if (!banner) return;
    const url = clean(artwork.teamBannerUrl);
    if (!url) {
      qsa('.oss-club-banner-artwork', banner).forEach((node) => node.remove());
      banner.classList.remove('has-artwork-background');
      delete banner.dataset.ossArtworkUrl;
      return;
    }
    if (banner.dataset.ossArtworkUrl === url && qs('.oss-club-banner-artwork', banner)) return;
    banner.dataset.ossArtworkUrl = url;
    probeFirst([url], (loadedUrl) => {
      if (!loadedUrl || !banner.isConnected) return;
      qsa('.oss-club-banner-artwork', banner).forEach((node) => node.remove());
      const img = document.createElement('img');
      img.className = 'oss-club-banner-artwork';
      img.src = loadedUrl;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      banner.prepend(img);
      banner.classList.add('has-artwork-background');
    });
  };

  const applyCustomIcon = (row, index, slug) => {
    const data = patchArtwork[index] || {};
    const customUrl = clean(data.iconUrl);
    if (!customUrl) return;
    const icon = qs('.oss-patch-icon', row);
    if (!icon) return;

    const existing = qsa('.oss-patch-brand-logo', icon);
    const normalizedCustomUrl = absoluteUrl(customUrl);
    const isExactCustom = existing.length === 1 && absoluteUrl(existing[0].src) === normalizedCustomUrl;
    if (row.dataset.ossCustomIconUrl === customUrl && isExactCustom) return;
    row.dataset.ossCustomIconUrl = customUrl;

    probeFirst([customUrl, autoLogoUrl(slug)], (loadedUrl) => {
      if (!loadedUrl || !icon.isConnected) return;
      qsa('.oss-patch-brand-logo', icon).forEach((node) => node.remove());
      const img = document.createElement('img');
      img.className = 'oss-patch-brand-logo';
      img.src = loadedUrl;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      icon.appendChild(img);
      icon.classList.add('has-brand-logo');
      row.dataset.ossBrandLogoChecked = slug;
    });
  };

  const applyPatchBackground = (row, index, slug) => {
    const data = patchArtwork[index] || {};
    const customUrl = clean(data.backgroundUrl);
    const candidates = customUrl ? [customUrl, ...autoBackgroundUrls(slug)] : autoBackgroundUrls(slug);
    const key = `${customUrl || 'auto'}|${slug}`;
    if (row.dataset.ossArtworkBgKey === key && qs('.oss-patch-artwork-background', row)) return;
    row.dataset.ossArtworkBgKey = key;

    probeFirst(candidates, (loadedUrl) => {
      if (!row.isConnected) return;
      qsa('.oss-patch-artwork-background', row).forEach((node) => node.remove());
      row.classList.remove('has-artwork-background');
      if (!loadedUrl) return;
      const img = document.createElement('img');
      img.className = 'oss-patch-artwork-background';
      img.src = loadedUrl;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      row.prepend(img);
      row.classList.add('has-artwork-background');
    });
  };

  const enhance = () => {
    applyTeamBanner();
    qsa('.oss-patch-panel .oss-patch-row').forEach((row, index) => {
      const nameNode = qs('.oss-patch-copy strong', row);
      const slug = row.dataset.ossPatchTheme || slugForName(nameNode && nameNode.textContent);
      applyCustomIcon(row, index, slug);
      applyPatchBackground(row, index, slug);
    });
  };

  let timer = null;
  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(enhance, 35);
  };

  const init = () => {
    enhance();
    const root = qs('.product-detail') || document.body;
    new MutationObserver(schedule).observe(root, { subtree: true, childList: true });
    window.setTimeout(enhance, 140);
    window.setTimeout(enhance, 550);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
